const UPDATE_TERMINAL = 'UPDATE_TERMINAL';
const UPDATE_TERMINAL_CLEAR = 'UPDATE_TERMINAL_CLEAR';
const UPDATE_CURRENT_PROMPT = 'UPDATE_CURRENT_PROMPT';
const UPDATE_EMPTY_TERMINAL = 'UPDATE_EMPTY_TERMINAL';
const UPDATE_COMMAND_AND_RESULTS = 'UPDATE_COMMAND_AND_RESULTS';
const CLEAR_SCREEN = 'CLEAR_SCREEN';

export { UPDATE_TERMINAL, UPDATE_TERMINAL_CLEAR, UPDATE_CURRENT_PROMPT, UPDATE_EMPTY_TERMINAL, UPDATE_COMMAND_AND_RESULTS, CLEAR_SCREEN };
